import {MobileBuyThirdPartyComponent} from './app_mobile/views/buy-third-party/buy-third-party.component';
import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {RouterModule, Routes} from "@angular/router";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {A11yModule} from "@angular/cdk/a11y";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {PortalModule} from "@angular/cdk/portal";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CdkStepperModule} from "@angular/cdk/stepper";
import {CdkTableModule} from "@angular/cdk/table";
import {CdkTreeModule} from "@angular/cdk/tree";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatBadgeModule} from "@angular/material/badge";
import {MatBottomSheetModule} from "@angular/material/bottom-sheet";
import {MatButtonModule} from "@angular/material/button";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatCardModule} from "@angular/material/card";
import {NgxFileDropModule} from "ngx-file-drop";
import {
  MatCheckboxModule,
  MAT_CHECKBOX_CLICK_ACTION
} from "@angular/material/checkbox";
import {MatChipsModule} from "@angular/material/chips";
import {MatStepperModule} from "@angular/material/stepper";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {
  MatDialogModule,
  MAT_DIALOG_DEFAULT_OPTIONS
} from "@angular/material/dialog";
import {MatDividerModule} from "@angular/material/divider";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatListModule} from "@angular/material/list";
import {MatMenuModule} from "@angular/material/menu";
import {MatNativeDateModule, MatRippleModule} from "@angular/material/core";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatProgressSpinner, MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatSliderModule} from "@angular/material/slider";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatTabsModule} from "@angular/material/tabs";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatTreeModule} from "@angular/material/tree";
import {MatVideoModule} from "mat-video";
import {MatSelectInfiniteScrollModule} from 'ng-mat-select-infinite-scroll';

import {JwtModule} from "@auth0/angular-jwt";

import {AppComponent} from "./app.component";
import {HomeComponent} from "./home/home.component";
import {CounterComponent} from "./counter/counter.component";
import {FetchDataComponent} from "./fetch-data/fetch-data.component";

import {MainNavComponent} from "./main-nav/main-nav.component";
import {PageNotFoundComponent} from "./Pages/page-not-found/page-not-found.component";
import {MainWindowComponent} from "./main-window/main-window.component";

import {RegisterComponent} from "./User/register/register.component";

import {AuthGuard} from "./Guards/auth-guard.guard";
import {getAuthToken} from "./api/AuthHeaders";
import {UserService} from "./Services/user.service";
import {AdvertisementService} from "./Services/advertisement.service";


import {MainService} from "./Services/service.service";

import {PreviousRouteService} from "./Services/previousroute.service";

import {SubscribtionComponent} from "./Subscribtion/subscribtion.component";
import {
  OverlayContainer,
  FullscreenOverlayContainer
} from "@angular/cdk/overlay";
import {ErrorSheetComponent} from "./Messages/error-sheet/error-sheet.component";
import {InformationSheetComponent} from "./Messages/information-sheet/information-sheet.component";
import {WarningSheetComponent} from "./Messages/warning-sheet/warning-sheet.component";
import {FooterComponent} from "./footer/footer.component";
import {DialogLoginComponent} from "./Dialogs/dialog.login/dialog.login.component";
import {EnterDialogComponent} from "./Dialogs/enter-dialog/enter-dialog.component";
import {Over18Guard} from "./Guards/over18-guard.guard";
import {EmptyPageComponent} from "./Pages/empty-page/empty-page.component";
import {AdvSmallComponent} from "./Adveristments/adv-small/adv-small.component";
import {FlexLayoutModule} from "@angular/flex-layout";
import {SearchSmallComponent} from "./Adv/search-small/search-small.component";
import {RegistrationSuccessComponent} from "./User/registration-success/registration-success.component";
import {ValidateEmailComponent} from "./User/validate-email/validate-email.component";
import {ValidatePhoneComponent} from "./User/validate-phone/validate-phone.component";

import {AdvDetailComponent} from "./Adveristments/adv-detail/adv-detail.component";
import {AdvEditComponent} from "./Adveristments/adv-edit/adv-edit.component";
import {SearchLargeComponent} from "./Adv/search-large/search-large.component";
import {ResetPasswordComponent} from "./User/reset-password/reset-password.component";
import {NewPasswordComponent} from "./User/new-password/new-password.component";
import {AdvUserMessagesComponent} from "./Adveristments/adv-user-messages/adv-user-messages.component";
import {AdvUserAdvertisementsComponent} from "./Adveristments/adv-user-advertisements/adv-user-advertisements.component";
import {AdvUserAdvertisementsNonDemoComponent} from "./Adveristments/adv-user-advertisements-non-demo/adv-user-advertisements-non-demo.component";
import {SearchResultsComponent} from "./Adv/search-results/search-results.component";
import {AgmCoreModule} from "@agm/core";
import {BytesPipe} from "./Pipes/bytes-pipe.pipe";
import {UploadFileQueueComponent} from "./Components/upload-file-queue/upload-file-queue.component";
import {UploadFileComponent} from "./Components/upload-file/upload-file.component";
import {UploadInputForDirective} from "./Directives/upload-input-for.directive";
import {LoadImageDirective} from './Directives/load-image.directive';

//import { DragDropDirective } from "./Directives/drag-drop.directive"
import {NgxGalleryModule} from "ngx-gallery";
import {ContactUsComponent} from "./Cms/contact-us/contact-us.component";
import {AboutUsComponent} from "./Cms/about-us/about-us.component";
import {HelpAndFaqComponent} from "./Cms/help-and-faq/help-and-faq.component";
import {PrivacyPolicyComponent} from "./Cms/privacy-policy/privacy-policy.component";
import {TermOfUseComponent} from "./Cms/term-of-use/term-of-use.component";

import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {ThxDialogComponent} from "./Dialogs/thx-dialog/thx-dialog.component";

import {AdWritterComponent} from "./AdWritter/AdWritter.component";
import {AdvWithUsComponent} from "./AdvWithUs/AdvWithUs.component";

import {CookieService} from "ngx-cookie-service";
import {RecaptchaModule} from "ng-recaptcha";
import {CaptchaService} from "./Services/captcha.service";
import {VersionCheckService} from "./Services/version-check.service";
import {CompareVersionsComponent, CompareVersionsPageComponent} from "./Cms/compare-versions/compare-versions.component";
import {AdvertiseWithUsComponent} from "./Cms/advertise-with-us/advertise-with-us.component";
import {DatingTipsComponent} from "./Cms/dating-tips/dating-tips.component";
import {ThxLogoutDialogComponent} from "./Dialogs/thx-logout-dialog/thx-logout-dialog.component";
import {AdvManageComponent} from "./Adveristments/adv-manage/adv-manage.component";
import {EmojiShareModule} from './Components/emojipicker/emoji-share-module';
import {ContactUser} from "./Adveristments/adv-contact-user/contact-user.component";
import {ImageAttachComponent} from "./Components/image-attach/image-attach.component";
import {ConversationsListComponent} from "./Conversations/conv-list/conv-list.component";
import {ConfirmationSheetComponent} from "./Messages/confirm-sheet/confirmation-sheet.component";
import {AppNavComponent} from "./Nav/app-nav.component";
import {SendConversationMessageComponent} from "./Components/send-message/send-conversation-message.component";
import {SubscribtionService} from "./Services/subscribtion.service";
import {SubscribtionConfirmComponent} from "./SubscriptionConfirm/SubscribtionConfirm.component";
import {SubscriptionInformationComponent} from "./SubscriptionInformation/subscriptionInformation.component";
import {CancelSubscriptionComponent} from "./Dialogs/cancelSubscription/cancelSubscription.component";
import {RegistrationHolderComponent} from "./User/registration-holder/registration-holder.component";
import {ResetPasswordHolderComponent} from "./User/reset-password-holder/reset-password-holder.component";
import {NewPasswordHolderComponent} from "./User/new-password-holder/new-password-holder.component";
import {ValidatePhoneHolderComponent} from "./User/validate-phone-holder/validate-phone-holder.component";
import {ImageDragDropComponent} from "./Components/image-drag-drop/image-drag-drop.component";

import {DropzoneModule} from 'ngx-dropzone-wrapper';
import {PremiumAdTokenPayment} from "./Components/premium-ad-token/premium-ad-token-paymen.component";
import {TokenExpiredDialogComponent} from "./Dialogs/token-expired-dialog/token-expired-dialog.component";
import {NewVersionDialogComponent} from "./Dialogs/new-version-dialog/new-version-dialog.component";
import {SeoTextsWrapperComponent} from "./Components/seo-texts-wrapper/seo-texts-wrapper.component";
import {AppRoutingModule} from "./app-routing.module";

import {LoginComponent as MobileLoginComponent} from './app_mobile/views/login/login.component';
import {RegistrationComponent as MobileRegistrationComponent} from './app_mobile/views/registration/registration.component';
import {AccountComponent as MobileAccountComponent} from './app_mobile/views/account/account.component';
import {FooterComponent as MobileFooterComponent} from './app_mobile/components/navigation/footer/footer.component';
import {HeaderComponent as MobileHeaderComponent} from './app_mobile/components/navigation/header/header.component';
import {MobileHomeComponent} from './app_mobile/views/home/home.component';
import {SearchComponent as MobileSearchComponent} from './app_mobile/views/search/search.component';
import {ResultsComponent as MobileResultsComponent} from './app_mobile/views/results/results.component';
import {AdvertisementComponent as MobileAdvertisementComponent} from './app_mobile/views/advertisement/advertisement.component';
import {ConversationComponent as MobileConversationComponent} from './app_mobile/views/conversation/conversation.component';
import {MaterialModule} from "./app_mobile/material.module";
import {NgxImageSwiperModule} from "ngx-image-swiper";
import {ChatModule} from "./app_mobile/components/chat/chat.module";
import {AppMobileComponent} from "./app_mobile/app_mobile.component";
import {SubscribtionComponent as MobileSubscribtionComponent} from './app_mobile/views/subscribtion/subscribtion.component';
import {SubscriptionInformationComponent as MobileSubscriptionInformationComponent} from './app_mobile/views/subscription-information/subscription-information.component';
import {SubscribtionConfirmComponent as MobileSubscribtionConfirmComponent} from './app_mobile/views/subscription-confirm/subscription-confirm.component';
import {UserAdvertisementsComponent as MobileUserAdvertisementsComponent} from './app_mobile/views/user-advertisements/user-advertisements.component';
import {SeoTextsComponent as MobileSeoTexts} from './app_mobile/components/seo-texts/seo-texts.component';
import {AdvEditComponent as MobileAdvEditComponent} from './app_mobile/views/advertisement-edit/advertisement-edit.component';
import {NonDemoAdsComponent as MobileNonDemoAdsComponent} from './app_mobile/views/non-demo-ads/non-demo-ads.component';
import {RouteSeachResults as MobileRouteSeachResults} from './app_mobile/components/route-search-results/route-search-results.component';
import {MobileAdWritterComponent} from './app_mobile/views/AdWritter/AdWritter.component';
import {MobileCompareVersionsComponent} from './app_mobile/components/compare-versions/compare-versions.component';
import {MobileTermsDialogComponent} from './app_mobile/components/terms-dialog/terms-dialog.component';
import {MobileCompareVersionsPageComponent} from './app_mobile/components/compare-versions/compare-versions.component';
import {environment} from '../environments/environment';


import {ActionService} from './app_mobile/action.service';

import isMobile from "is-mobile";
import {SearchRouteService} from "./Services/searchroute.service";
import {ResultsModules} from "./app_mobile/views/results/results.module";
import {GoogleAnalyticsService} from "./Services/google.analytics.service";
import {RouteSeachResults} from "./Adv/route-search-results/route-search-results.component";
import {API_BASE_URL} from "./api/WickedApiClient";

import {BuyBanerComponent} from './buy-baner/buy-baner.component';
import {BuyThirdPartyComponent} from './buy-third-party/buy-third-party.component';
import {BanerTokenPaymentComponent} from './Components/baner-token-payment/baner-token-payment.component';
import {BannerZoneMapModule} from './Components/banner-zone-map/baner-zone-map.module';
import {DeleteAccountDialog} from './Dialogs/delete-account-dialog/delete-account-dialog.component';

import {APP_BASE_HREF} from '@angular/common';

@NgModule({
  declarations: [
    AppMobileComponent,
    AppComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    MainNavComponent,
    MainWindowComponent,
    RegisterComponent,
    RegistrationHolderComponent,
    ResetPasswordHolderComponent,
    NewPasswordHolderComponent,
    ValidatePhoneHolderComponent,
    PageNotFoundComponent,
    ImageAttachComponent,
    EmptyPageComponent,
    RegistrationSuccessComponent,
    ResetPasswordComponent,
    NewPasswordComponent,
    ValidateEmailComponent,
    ConversationsListComponent,
    ValidatePhoneComponent,
    SubscribtionComponent,
    AdvDetailComponent,
    AdvEditComponent,
    AdvManageComponent,
    SearchLargeComponent,
    SearchResultsComponent,
    CancelSubscriptionComponent,
    AdWritterComponent,
    AdvWithUsComponent,
    SeoTextsWrapperComponent,
    // Sheets
    ErrorSheetComponent,
    InformationSheetComponent,
    WarningSheetComponent,
    ConfirmationSheetComponent,
    BuyBanerComponent,
    BuyThirdPartyComponent,

    SubscribtionConfirmComponent,
    SubscriptionInformationComponent,

    // Dialogs
    DialogLoginComponent,
    EnterDialogComponent,
    ThxDialogComponent,
    DeleteAccountDialog,
    ThxLogoutDialogComponent,
    TokenExpiredDialogComponent,
    NewVersionDialogComponent,
    FooterComponent,

    // Adv
    AdvSmallComponent,
    AdvUserMessagesComponent,
    AdvUserAdvertisementsComponent,
    AdvUserAdvertisementsNonDemoComponent,
    ContactUser,

    //Search
    SearchSmallComponent,
    RouteSeachResults,

    //components
    UploadFileQueueComponent,
    UploadFileComponent,
    UploadInputForDirective,
    LoadImageDirective,
    PremiumAdTokenPayment,
    BanerTokenPaymentComponent,
    //DragDropDirective,
    BytesPipe,
    //CMS
    ContactUsComponent,
    AboutUsComponent,
    CompareVersionsComponent,
    CompareVersionsPageComponent,
    AdvertiseWithUsComponent,
    DatingTipsComponent,
    HelpAndFaqComponent,
    PrivacyPolicyComponent,
    TermOfUseComponent,
    AppNavComponent,
    SendConversationMessageComponent,
    ImageDragDropComponent,

    //Mobile components
    MobileLoginComponent,
    MobileRegistrationComponent,
    MobileAccountComponent,
    MobileFooterComponent,
    MobileHeaderComponent,
    MobileHomeComponent,
    MobileSearchComponent,
    MobileAdvertisementComponent,
    MobileConversationComponent,
    MobileSubscribtionComponent,
    MobileSubscriptionInformationComponent,
    MobileSubscribtionConfirmComponent,
    MobileUserAdvertisementsComponent,
    MobileSeoTexts,
    MobileAdvEditComponent,
    MobileNonDemoAdsComponent,
    MobileRouteSeachResults,
    MobileAdWritterComponent,
    SeoTextsWrapperComponent,
    MobileCompareVersionsComponent,
    MobileTermsDialogComponent,
    MobileCompareVersionsPageComponent,
    MobileBuyThirdPartyComponent
  ],
  exports: [
    MatBadgeModule,
  ],
  imports: [
    BrowserModule.withServerTransition({appId: "ng-cli-universal"}),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DropzoneModule,

    AppRoutingModule,
    ResultsModules,
    BrowserAnimationsModule,
    A11yModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    NgxFileDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatVideoModule,
    MatSelectInfiniteScrollModule,
    PortalModule,
    ScrollingModule,
    FlexLayoutModule,
    NgxGalleryModule,
    NgxMatSelectSearchModule,
    EmojiShareModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: getAuthToken
        //   whitelistedDomains: ["example.com"],
        //   blacklistedRoutes: ["example.com/examplebadroute/"]
      }
    }),
    AgmCoreModule.forRoot({
      //  apiKey: 'AIzaSyDABfhTrwAKzM_-XU4jVcVaMpLddwPa17k'
      apiKey: "AIzaSyBIdGrZGaJCH2juKEk5ugIjzx4SwDqgcvI"
    }),
    RecaptchaModule,
    MaterialModule,
    NgxImageSwiperModule,
    ChatModule,
    BannerZoneMapModule
  ],
  providers: [
    {provide: APP_BASE_HREF, useValue: '/'},
    CookieService,
    UserService,
    AdvertisementService,
    SearchRouteService,
    MainService,
    CaptchaService,
    PreviousRouteService,
    SubscribtionService,
    VersionCheckService,
    ActionService,
    GoogleAnalyticsService,
    {provide: MAT_CHECKBOX_CLICK_ACTION, useValue: "check"},
    {provide: API_BASE_URL, useValue: environment.apiBaseUrl},
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: true,
        closeOnNavigation: true,
        disableClose: false,
        maxHeight: "90%"
      }
    },
    {provide: OverlayContainer, useClass: FullscreenOverlayContainer}
  ],
  entryComponents: [
    // Sheets
    AppComponent,
    MobileHomeComponent,
    AppMobileComponent,
    ErrorSheetComponent,
    CancelSubscriptionComponent,
    InformationSheetComponent,
    WarningSheetComponent,
    ConfirmationSheetComponent,
    // Dialogs
    CompareVersionsComponent,
    DialogLoginComponent,
    EnterDialogComponent,
    ThxDialogComponent,
    DeleteAccountDialog,
    ContactUser,
    ThxLogoutDialogComponent,
    TokenExpiredDialogComponent,
    NewVersionDialogComponent,
    RegisterComponent,
    ValidatePhoneComponent,
    ResetPasswordComponent,
    NewPasswordComponent,
    MatProgressSpinner,

    //mobile
    MobileLoginComponent,
    MobileRegistrationComponent,
    MobileAccountComponent,
    MobileFooterComponent,
    MobileHeaderComponent,
    MobileHomeComponent,
    MobileSearchComponent,
    MobileAdvertisementComponent,
    MobileConversationComponent,
    MobileSubscribtionComponent,
    MobileSubscriptionInformationComponent,
    MobileSubscribtionConfirmComponent,
    MobileUserAdvertisementsComponent,
    MobileSeoTexts,
    MobileAdvEditComponent,
    MobileNonDemoAdsComponent,
    MobileRouteSeachResults,
    MobileAdWritterComponent,
    SeoTextsWrapperComponent,
    MobileCompareVersionsComponent,
    MobileTermsDialogComponent,
    MobileCompareVersionsPageComponent,
    MobileBuyThirdPartyComponent
  ],
})


export class AppModule {
  ngDoBootstrap(app) {
    console.log('in app module');

    if(isMobile() ||
      environment.name == "CORDOVA") {
      console.log('bootstrap cordova');
      app.bootstrap(AppMobileComponent);
    } else {
      app.bootstrap(AppComponent);
    }

  }
}
